export enum enumFENDesc {
'Movement Details Outstanding'='Movement Details Outstanding',
'Saswitch ATM Balance Enquiry'='Saswitch ATM Balance Enquiry',
'Saswitch ATM Withdrawal' = 'Saswitch ATM Withdrawal',
'Saswitch ATM Insufficient Funds'='Saswitch ATM Insufficient Funds',
'Own ATM Balance Enquiry'='Own ATM Balance Enquiry',
'Own ATM Withdrawal'='Own ATM Withdrawal',
'Own ATM Insufficient Funds'='Own ATM Insufficient Funds',
'ACB Incoming Credits'='ACB Incoming Credits',
'ACB Incoming Debits'='ACB Incoming Debits',
'ACB Sameday Outgoing Transfer'='ACB Sameday Outgoing Transfer',
'ACB Rejection Fee'='ACB Rejection Fee',
'SP Interim Statement'='SP Interim Statement',
'Internal Transfer To'='Internal Transfer To',
'SP QDI For CardHolder'='SP QDI For CardHolder',
'SP QDI For Service Point'='SP QDI For Service Point',
'Monthly Account Fee'='Monthly Account Fee',
'ABSA Cash Deposit From'='ABSA Cash Deposit From',
'Post Office Cash Deposit From'='Post Office Cash Deposit From',
'Lost Card'='Lost Card',
'Stop Order'='Stop Order',
'Saambou Conversion Balance Debit'='Saambou Conversion Balance Debit',
'Saambou Conversion Balance Credit'='Saambou Conversion Balance Credit',
'NAD Balance Enq NoU'='NAD Balance Enq NoU',
'NAD Settlement NoU'='NAD Settlement NoU',
'NAD Settlement NoU 51'='NAD Settlement NoU 51',
'Saambou ACB Incoming Credits'='Saambou ACB Incoming Credits',
'Batch QDI From'='Batch QDI From',
'Batch QDI Fee CH From'='Batch QDI Fee CH From',
'Batch QDI Fee SP From'='Batch QDI Fee SP From',
'Internal Transfer From'='Internal Transfer From',
'Saambou ACB Incoming Debits'='Saambou ACB Incoming Debits',
'Saambou ACB Rejection Fee'='Saambou ACB Rejection Fee',
'Saambou ACB SSV Fee'='Saambou ACB SSV Fee',
'Saswitch ATM Invalid PIN'='Saswitch ATM Invalid PIN',
'Saswitch ATM Daily Lim Exceeded'='Saswitch ATM Daily Lim Exceeded',
'Debit Card Purchase'='Debit Card Purchase',
'SP Terminal Transfer From'='SP Terminal Transfer From',
// 'Funds On Hold'='Funds On Hold',
'Funds Released'='Funds Released',
'Saambou ACB Cheques'='Saambou ACB Cheques',
'SEDI Settlement'='SEDI Settlement',
'SEDI Card Validation NoU'='SEDI Card Validation NoU',
'SEDI Registration NoU'='SEDI Registration NoU',
'MATM Withdrawal NoU'='MATM Withdrawal NoU',
'MATM Card Validation'='MATM Card Validation',
'ACB SameDay Outgoing Debit'='ACB SameDay Outgoing Debit',
'NAD Settlement NoU 55'='NAD Settlement NoU 55',
'NAD Settlement NoU 61'='NAD Settlement NoU 61',
'Own ATM Invalid PIN'='Own ATM Invalid PIN',
'Own ATM Daily Limit Exceeded'='Own ATM Daily Limit Exceeded',
'SEDI Settlement NoU 55'='SEDI Settlement NoU 55',
'SEDI Card Validation NoU 55'='SEDI Card Validation NoU 55',
'SEDI Registration NoU 55'='SEDI Registration NoU 55',
'SEDI Settlement NoU 51'='SEDI Settlement NoU 51',
'SEDI Card Validation NoU 51'='SEDI Card Validation NoU 51',
'SEDI Registration NoU 51'='SEDI Registration NoU 51',
'SEDI Settlement NoU 61'='SEDI Settlement NoU 61',
'SEDI Card Validation NoU 61'='SEDI Card Validation NoU 61',
'SEDI Registration NoU 61'='SEDI Registration NoU 61',
'SEDI Settlement NoU 62'='SEDI Settlement NoU 62',
'SEDI Card Validation NoU 62'='SEDI Card Validation NoU 62',
'SEDI Registration NoU 62'='SEDI Registration NoU 62',
'SEDI Settlement NoU 12'='SEDI Settlement NoU 12',
'SEDI Card Validation NoU 12'='SEDI Card Validation NoU 12',
'SEDI Registration NoU 12'='SEDI Registration NoU 12',
'* NAD Withdrawal NoU (Issuing)'='* NAD Withdrawal NoU (Issuing)',
'* NAD Balance Enq NoU (Issuing)'='* NAD Balance Enq NoU (Issuing)',
'NAD Settlement NoU 62'='NAD Settlement NoU 62',
'NAD Settlement NoU 12'='NAD Settlement NoU 12',
'NAD Balance Enq NoU 61'='NAD Balance Enq NoU 61',
'NAD Balance Enq NoU 51'='NAD Balance Enq NoU 51',
'NAD Balance Enq NoU 55'='NAD Balance Enq NoU 55',
'NAD Balance Enq NoU 12'='NAD Balance Enq NoU 12',
'NAD Balance Enq NoU 62'='NAD Balance Enq NoU 62',
'NAD Settlement OnUs'='NAD Settlement OnUs',
'NAD Balance Enquiry OnUs'='NAD Balance Enquiry OnUs',
'SEDI Settlement OnUs'='SEDI Settlement OnUs',
'SEDI Card Validation OnUs'='SEDI Card Validation OnUs',
'SEDI Registration OnUs'='SEDI Registration OnUs',
'Batch QDI To'='Batch QDI To',
'Batch QDI Fee CH To'='Batch QDI Fee CH To',
'Batch QDI Fee SP To'='Batch QDI Fee SP To',
'SP Terminal Transfer To'='SP Terminal Transfer To',
'NAD Settlement OnUs TM'='NAD Settlement OnUs TM',
'SEDI Settlement TM OnUs'='SEDI Settlement TM OnUs',
'NAD Balance Enquiry OnUs TM'='NAD Balance Enquiry OnUs TM',
'SEDI Card Validation TM OnUs'='SEDI Card Validation TM OnUs',
'SEDI Registration TM OnUs'='SEDI Registration TM OnUs',
'Internet Balance Enquiry'='Internet Balance Enquiry',
'Internet Internal Transfer From'='Internet Internal Transfer From',
'Internet Internal Transfer To'='Internet Internal Transfer To',
'Internet External Transfer'='Internet External Transfer',
'Internet Statement Fee'='Internet Statement Fee',
'SP QMCard Terminal Transfer From'='SP QMCard Terminal Transfer From',
'SP QMCard Terminal Transfer To'='SP QMCard Terminal Transfer To',
'ABSA Cash Deposit To'='ABSA Cash Deposit To',
'ABSA Cheque Deposit From'='ABSA Cheque Deposit From',
'ABSA Cheque Deposit To'='ABSA Cheque Deposit To',
'Interest Paid'='Interest Paid',
'Account Closures Fee (CT)'='Account Closures Fee (CT)',
'Account Closures Write=Off (DT)'='Account Closures Write=Off (DT)',
'Post Office Cash Deposits To'='Post Office Cash Deposits To',
'Payrol Transfer From'='Payrol Transfer From',
'Payrol Transfer To'='Payrol Transfer To',
'Debit Card Balance Enquiry'='Debit Card Balance Enquiry',
'Debit Card withdrawal'='Debit Card withdrawal',
'SureBank Fee Realization'='SureBank Fee Realization',
'OTC Statement Enq'='OTC Statement Enq',
'Card Related Statement Enquiry'='Card Related Statement Enquiry',
'Terminal Identification'='Terminal Identification',
'Terminal Purchase : Pocket'='Terminal Purchase : Pocket',
'OnUs Supervisor ID From'='OnUs Supervisor ID From',
'OnUs Supervisor ID To'='OnUs Supervisor ID To',
'OnUs MSA Terminal Purchase From'='OnUs MSA Terminal Purchase From',
'OnUs MSA Terminal Purchase To'='OnUs MSA Terminal Purchase To',
'AEDO Contract Registered'='AEDO Contract Registered',
// 'AEDO Instruction Registered'='AEDO Instruction Registered',
'AEDO Deduction'='AEDO Deduction',
'AEDO Payment Received'='AEDO Payment Received',
'AEDO Instruction Registered'='AEDO Instruction Registered',
'AEDO Receipt'='AEDO Receipt',
'AEDO Failed Transaction'='AEDO Failed Transaction',
'NAEDO Receipt'='NAEDO Receipt',
'NAEDO Failed Transaction'='NAEDO Failed Transaction',
'NAEDO Deduction'='NAEDO Deduction',
'Credit Transfer (Card)'='Credit Transfer (Card)',
'Credit Transfer Received (Card)'='Credit Transfer Received (Card)',
'Credit Transfer'='Credit Transfer',
'Credit Transfer Received'='Credit Transfer Received',
'Credit Transfer Authorised (Card)'='Credit Transfer Authorised (Card)',
'Credit Transfer Registered (Card)'='Credit Transfer Registered (Card)',
'Credit Transfer Authorised'='Credit Transfer Authorised',
'Credit Transfer Registered'='Credit Transfer Registered',
'QDI Transfer Authorised'='QDI Transfer Authorised',
'QDI Transfer Registered'='QDI Transfer Registered',
'QDI Transfer'='QDI Transfer',
'QDI Receipt'='QDI Receipt',
'NAEDO Payment Received'='NAEDO Payment Received',
'Failed Credit Transfer (Card)'='Failed Credit Transfer (Card)',
'Failed Credit Transfer Received (Card)'='Failed Credit Transfer Received (Card)',
'Failed Credit Transfer'='Failed Credit Transfer',
'Failed Credit Transfer Received'='Failed Credit Transfer Received',
'QDI Received'='QDI Received',
'Failed QDI Transfer'='Failed QDI Transfer',
'Failed QDI Received'='Failed QDI Received',
'NAEDO Instruction Registered'='NAEDO Instruction Registered',
'NAEDO Contract Registered'='NAEDO Contract Registered',
'Failed NAEDO Registration'='Failed NAEDO Registration',
'Failed NAEDO Contract Registered'='Failed NAEDO Contract Registered',
'Failed Credit Transfer Authorized (Card)'='Failed Credit Transfer Authorized (Card)',
'Failed Credit Transfer Registered (Card)'='Failed Credit Transfer Registered (Card)',
'Failed Credit Transfer Authorized'='Failed Credit Transfer Authorized',
'Failed Credit Transfer Registered'='Failed Credit Transfer Registered',
'Failed QDI Transfer Authorized'='Failed QDI Transfer Authorized',
'Failed QDI Transfer Registered'='Failed QDI Transfer Registered',
'QDI Transfer (H)'='QDI Transfer (H)',
'QDI Receipt (H)'='QDI Receipt (H)',
'Failed QDI Transfer (H)'='Failed QDI Transfer (H)',
'Failed QDI Receipt (H)'='Failed QDI Receipt (H)',
'Internat. Card Purchase'='Internat. Card Purchase',
'Internat. Card Withdrawal'='Internat. Card Withdrawal',
'Internat. Card Balance Enq'='Internat. Card Balance Enq',
'Telebank Balance Enq'='Telebank Balance Enq',
'Card Replacement Req'='Card Replacement Req',
'Telebank Statement Enq'='Telebank Statement Enq',
'NAEDO Reversal'='NAEDO Reversal',
// 'Electronic Funds Transfer'='Electronic Funds Transfer',
'OTC Statement Refund'='OTC Statement Refund',
'Portal Balance Enq'='Portal Balance Enq',
'Portal Statement Enq'='Portal Statement Enq',
'Portal Abridged Statement'='Portal Abridged Statement',
'Electronic Deposit'='Electronic Deposit',
'Cell Bank Activation'='Cell Bank Activation',
'CellPhone Balance Enquiry'='CellPhone Balance Enquiry',
'CellPhone Mini Statement'='CellPhone Mini Statement',
'Electronic Deposit From'='Electronic Deposit From',
'Electronic Funds Transfer'='Electronic Funds Transfer',
'Cell Bank Activation via Card'='Cell Bank Activation via Card',
'Acquirer Payer Fee = Merchant'='Acquirer Payer Fee = Merchant',
'Acquirer Payer Fee = CSP'='Acquirer Payer Fee = CSP',
'NAEDO Receipt = Sponsored'='NAEDO Receipt = Sponsored',
// 'NAEDO Failed = Sponsored'='NAEDO Failed = Sponsored',
'AEDO Receipt = PF Option'='AEDO Receipt = PF Option',
// 'AEDO Tracking = PF Option'='AEDO Tracking = PF Option',
// 'AEDO Failed = PF Option'='AEDO Failed = PF Option',
'NAEDO Receipt = PF Option'='NAEDO Receipt = PF Option',
// 'NAEDO Tracking = PF Option'='NAEDO Tracking = PF Option',
// 'NAEDO Failed = PF Option'='NAEDO Failed = PF Option',
'AEDO Deduction = PF'='AEDO Deduction = PF',
'AEDO Payment Received = PF Option'='AEDO Payment Received = PF Option',
'AEDO Tracking = PF'='AEDO Tracking = PF',
'AEDO Tracking = PF Option'='AEDO Tracking = PF Option',
'AEDO Failed = PF'='AEDO Failed = PF',
'AEDO Failed = PF Option'='AEDO Failed = PF Option',
'NAEDO Deduction = PF'='NAEDO Deduction = PF',
'NAEDO Payment Received = PF Option'='NAEDO Payment Received = PF Option',
'NAEDO Tracking = PF'='NAEDO Tracking = PF',
'NAEDO Tracking = PF Option'='NAEDO Tracking = PF Option',
'NAEDO Failed = PF'='NAEDO Failed = PF',
'NAEDO Failed = PF Option'='NAEDO Failed = PF Option',
'NAEDO Receipt = CSP'='NAEDO Receipt = CSP',
'NAEDO Tracking = CSP'='NAEDO Tracking = CSP',
'NAEDO Failed = CSP'='NAEDO Failed = CSP',
'NAEDO Payment Received = CSP'='NAEDO Payment Received = CSP',
'NAEDO Payment Received = Sponsored'='NAEDO Payment Received = Sponsored',
'NAEDO Failed = Sponsored'='NAEDO Failed = Sponsored',
'Card Delivery Fee'='Card Delivery Fee',
// 'NAEDO Recalled'='NAEDO Recalled',
// 'NAEDO Recall Failed'='NAEDO Recall Failed',
// 'AEDO Recalled'='AEDO Recalled',
// 'AEDO Recall Failed'='AEDO Recall Failed',
'NAEDO Receipt = Settlement'='NAEDO Receipt = Settlement',
'NAEDO Failed = PF Inc'='NAEDO Failed = PF Inc',
'AEDO Receipt = Settlement'='AEDO Receipt = Settlement',
'AEDO Failed = PF Inc'='AEDO Failed = PF Inc',
'AEDO Receipt = Funds Trf'='AEDO Receipt = Funds Trf',
'AEDO Receipt = PF Inc'='AEDO Receipt = PF Inc',
'NAEDO Receipt = Funds Trf'='NAEDO Receipt = Funds Trf',
'NAEDO Receipt = PF Inc'='NAEDO Receipt = PF Inc',
'AEDO Deduction = PF Inc'='AEDO Deduction = PF Inc',
'AEDO Settlement'='AEDO Settlement',
'AEDO Settlement = Funds Trf'='AEDO Settlement = Funds Trf',
'AEDO Payment Received = PF Inc'='AEDO Payment Received = PF Inc',
'NAEDO Deduction = PF Inc'='NAEDO Deduction = PF Inc',
'NAEDO Settlement'='NAEDO Settlement',
'NAEDO Settlement = Funds Trf'='NAEDO Settlement = Funds Trf',
'NAEDO Payment Received = PF Inc'='NAEDO Payment Received = PF Inc',
'Card Replacement (Portal)'='Card Replacement (Portal)',
'Card Replacement'='Card Replacement',
'First Card Issue'='First Card Issue',
'Portal First Card Issue'='Portal First Card Issue',
'CellBank Session'='CellBank Session',
'ATM Enquiry Error'='ATM Enquiry Error',
'ATM Withdrawal Error'='ATM Withdrawal Error',
'POS Purchase Error'='POS Purchase Error',
'POS Withdrawal Error'='POS Withdrawal Error',
'Debit Order Rejected'='Debit Order Rejected',
'AEDO Receipt = CSP Funds Trf'='AEDO Receipt = CSP Funds Trf',
'AEDO Receipt = CSP PF Inc'='AEDO Receipt = CSP PF Inc',
'NAEDO Receipt = CSP Funds Trf'='NAEDO Receipt = CSP Funds Trf',
'NAEDO Receipt = CSP PF Inc'='NAEDO Receipt = CSP PF Inc',
'AEDO Settlement PF = CSP Funds Trf'='AEDO Settlement PF = CSP Funds Trf',
'AEDO Payment Received = CSP PF Inc'='AEDO Payment Received = CSP PF Inc',
'NAEDO Settlement = CSP Funds Trf'='NAEDO Settlement = CSP Funds Trf',
'NAEDO Payment Received = CSP PF Inc'='NAEDO Payment Received = CSP PF Inc',
'Debit Order (Insufficient funds)'='Debit Order (Insufficient funds)',
'Debit Order (Limit Exceeded)'='Debit Order (Limit Exceeded)',
'Debit Order (Not provided for)'='Debit Order (Not provided for)',
'Debit Order (General)'='Debit Order (General)',
'Swift Transfer Credit'='Swift Transfer Credit',
'Swift Transfer'='Swift Transfer',
'Electronic Card Deposit'='Electronic Card Deposit',
'Electronic Card Deposit From'='Electronic Card Deposit From',
'SMS Notification'='SMS Notification',
'ABSA Electronic Deposit'='ABSA Electronic Deposit',
'Collection Debit Order'='Collection Debit Order',
'Returned Collection DO'='Returned Collection DO',
'Disputed Collection DO'='Disputed Collection DO',
'Credit Returned'='Credit Returned',
'CellPOS Transfer'='CellPOS Transfer',
'CellPOS Credit'='CellPOS Credit',
'Convenience Card Cancelled'='Convenience Card Cancelled',
'Debit Card Balance Enquiry Error'='Debit Card Balance Enquiry Error',
'CellBank USSD Balance Enquiry'='CellBank USSD Balance Enquiry',
'CellBank PAN Balance Enquiry'='CellBank PAN Balance Enquiry',
'Device Activation'='Device Activation',
'Device Initialization'='Device Initialization',
'Device Authorization'='Device Authorization',
'SSD Balance Enquiry'='SSD Balance Enquiry',
'SSD Card Validation'='SSD Card Validation',
'Failed SSD Validation 51'='Failed SSD Validation 51',
'Failed SSD Validation 55'='Failed SSD Validation 55',
'Failed SSD Validation 62'='Failed SSD Validation 62',
'Failed SSD Validation'='Failed SSD Validation',
'SSD Withdrawal'='SSD Withdrawal',
'SSD Receipt'='SSD Receipt',
'Failed SSD Receipt 51'='Failed SSD Receipt 51',
'Failed SSD Receipt 55'='Failed SSD Receipt 55',
'Failed SSD Receipt 61'='Failed SSD Receipt 61',
'Failed SSD Receipt 62'='Failed SSD Receipt 62',
'Failed SSD Receipt'='Failed SSD Receipt',
'Failed AEDO Registration'='Failed AEDO Registration',
'Failed AEDO Registration 55'='Failed AEDO Registration 55',
'SASSA Transfer'='SASSA Transfer',
'SASSA Receipt'='SASSA Receipt',
'SASSA Transfer Failed'='SASSA Transfer Failed',
'SASSA Receipt Failed'='SASSA Receipt Failed',
'SASSA Dispute'='SASSA Dispute',
'AEDO Recalled'='AEDO Recalled',
'AEDO Recall Failed'='AEDO Recall Failed',
'NAEDO Recalled'='NAEDO Recalled',
'NAEDO Recall Failed'='NAEDO Recall Failed',
'AirTime Purchase'='AirTime Purchase',
'AirTime Paid'='AirTime Paid',
'Electricity Purchase'='Electricity Purchase',
'Electricity Paid'='Electricity Paid',
'Wizzit Division Debits'='Wizzit Division Debits',
'Wizzit Division Credits'='Wizzit Division Credits',
'Wizzit Division Transfer'='Wizzit Division Transfer',
'Facility reset'='Facility reset',
'Facility reset by sponsor'='Facility reset by sponsor',
'SMS OTP'='SMS OTP',
'Token Usage'='Token Usage',
'Pocket Load'='Pocket Load',
'Surecard=Surecard Transfer'='Surecard=Surecard Transfer',
'Electronic Transfer'='Electronic Transfer',
'NAEDO Deduction Dispute'='NAEDO Deduction Dispute',
'Funds On Hold To Be Authorised'='Funds On Hold To Be Authorised',
'ACB Credit Rejection'='ACB Credit Rejection',
'SWIFT Inc CT Rejection'='SWIFT Inc CT Rejection',
'Swift Incoming'='Swift Incoming',
'Account Closure with Fee'='Account Closure with Fee',
'Reservation Of Funds'='Reservation Of Funds',
'Debicheck Contract Reg NoU'='Debicheck Contract Reg NoU',
'Debicheck Failed Transaction'='Debicheck Failed Transaction',
'Debicheck Contract Reg OU From'='Debicheck Contract Reg OU From',
'Debicheck Contract Reg OU To'='Debicheck Contract Reg OU To',
'Debicheck Contract Reg OU'='Debicheck Contract Reg OU',
'Debicheck Settlement From'='Debicheck Settlement From',
'Debicheck Settlement To'='Debicheck Settlement To',
// 'Debicheck Deduction'='Debicheck Deduction',
'Debicheck Payment Received'='Debicheck Payment Received',
// 'Debicheck Contract Cancellation'='Debicheck Contract Cancellation',
// 'Debicheck Contract Cancellation Failed'='Debicheck Contract Cancellation Failed',
'Debicheck Receipt'='Debicheck Receipt',
'Debicheck Tracking'='Debicheck Tracking',
'Debicheck Recall'='Debicheck Recall',
'Debicheck Recall Failed'='Debicheck Recall Failed',
'Debicheck Dispute'='Debicheck Dispute',
'Debicheck Dispute Failed'='Debicheck Dispute Failed',
'Debicheck Receipt = Settlement'='Debicheck Receipt = Settlement',
'Debicheck Failed = PF Inc'='Debicheck Failed = PF Inc',
'Debicheck Receipt = Funds Trf'='Debicheck Receipt = Funds Trf',
'Debicheck Receipt = PF Inc'='Debicheck Receipt = PF Inc',
'Debicheck Receipt = CSP Funds Trf'='Debicheck Receipt = CSP Funds Trf',
'Debicheck Receipt = CSP PF Inc'='Debicheck Receipt = CSP PF Inc',
'Debicheck Settlement = PF Inc'='Debicheck Settlement = PF Inc',
'Debicheck Settlement'='Debicheck Settlement',
'Debicheck Settlement = Funds Trf'='Debicheck Settlement = Funds Trf',
'Debicheck Payment Received = PF Inc'='Debicheck Payment Received = PF Inc',
'Debicheck Settlement PF = CSP Funds Trf'='Debicheck Settlement PF = CSP Funds Trf',
'Debicheck Payment Received = CSP PF Inc'='Debicheck Payment Received = CSP PF Inc',
'Debicheck Amendment'='Debicheck Amendment',
'Debicheck Amendment Failed'='Debicheck Amendment Failed',
'Debicheck Suspention'='Debicheck Suspention',
'Debicheck Suspention Failed'='Debicheck Suspention Failed',
'Debicheck TT1 Contract Registration'='Debicheck TT1 Contract Registration',
'Debicheck TT2 Contract Registration'='Debicheck TT2 Contract Registration',
'Debicheck TT3 Contract Registration'='Debicheck TT3 Contract Registration',
'Debicheck Contract Cancellation'='Debicheck Contract Cancellation',
'Debicheck Contract Amendment'='Debicheck Contract Amendment',
'Debicheck Contract Cancellation Failed'='Debicheck Contract Cancellation Failed',
'Debicheck Contract Amendment Failed'='Debicheck Contract Amendment Failed',
'Debicheck Deduction'='Debicheck Deduction',
'Debicheck Deduction Failed'='Debicheck Deduction Failed',
'RTC Outgoing'='RTC Outgoing',
'RTC Incoming'='RTC Incoming',
'eCommerce Debit Local'='eCommerce Debit Local',
'RTC Balance Enq'='RTC Balance Enq',
'eCommerce Debit International'='eCommerce Debit International',
'Contactless Tap and Pay Local'='Contactless Tap and Pay Local',
'Contactless Tap and Pay Int'='Contactless Tap and Pay Int',
'eCommerce With 3DSecure Local'='eCommerce With 3DSecure Local',
'eCommerce With 3DSecure Int'='eCommerce With 3DSecure Int',
'POS Purchase with CashBack'='POS Purchase with CashBack',
'EMV Recurring Payment'='EMV Recurring Payment',
'ECommerce With PIN'='ECommerce With PIN',
'Debicheck TT1 Failed Reg'='Debicheck TT1 Failed Reg',
'Debicheck TT2 Failed Reg'='Debicheck TT2 Failed Reg',
'Debicheck TT3 Failed Reg'='Debicheck TT3 Failed Reg',
'AmberAgent Mini Statement'='AmberAgent Mini Statement',
'RTC Debit Rejection'='RTC Debit Rejection',
'RTC Credit Rejection'='RTC Credit Rejection',
'RTC Balance Enquiry Rejection'='RTC Balance Enquiry Rejection',
'Swift Incoming HV'='Swift Incoming HV',
'Funds On Hold'='Funds On Hold',
'Instant Payment IN'='Instant Payment IN',
'Pending Transaction'='Pending Transaction',
'ATM Contactless Local'='ATM Contactless Local',
'ATM Contactless Int'='ATM Contactless Int',
'Instant Payment OUT'='Instant Payment OUT',
'HV Instant Payment'='HV Instant Payment',
'Mobile App Activation'='Mobile App Activation',
'Settlement 3rd Party Transfer From'='Settlement 3rd Party Transfer From',
'Electronic Payment'='Electronic Payment',
'DC Settlement'='DC Settlement',
'DC Response'='DC Response',
'DC Settlement Incl PF'='DC Settlement Incl PF'
}

export namespace enumFENDesc {
  export function values() {
    return Object.keys(enumFENDesc).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
